import React from 'react';
import { Box, Flex, Paper, Text, Title } from '@mantine/core';
import { Eyebrow } from './primitives';

interface ActionShellProps {
  eyebrow: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  right?: React.ReactNode;
  color?: 'teal' | 'orange' | 'gray';
}

export const ActionShell: React.FC<ActionShellProps> = ({
  eyebrow,
  title,
  description,
  right,
  color = 'teal',
}) => {
  const bg =
    color === 'teal'
      ? 'var(--mantine-primary-color-light)'
      : color === 'orange'
        ? 'var(--mantine-color-orange-light)'
        : 'var(--mantine-color-default-hover)';
  const bar =
    color === 'teal'
      ? 'var(--mantine-primary-color-filled)'
      : color === 'orange'
        ? 'var(--mantine-color-orange-6)'
        : 'var(--mantine-color-default-border)';
  const eyeColor = color === 'gray' ? 'dimmed' : color;
  return (
    <Paper radius="lg" p={0} style={{ background: bg, border: 'none', overflow: 'hidden' }}>
      <Flex>
        <Box style={{ width: 4, background: bar, flexShrink: 0 }} />
        <Flex
          align="center"
          justify="space-between"
          gap="lg"
          wrap="wrap"
          style={{ flex: 1, padding: '22px 24px' }}
        >
          <Box style={{ flex: 1, minWidth: 280 }}>
            <Eyebrow color={eyeColor}>{eyebrow}</Eyebrow>
            <Title
              order={2}
              size="h3"
              mt={8}
              mb={6}
              style={{ letterSpacing: '-0.005em', lineHeight: 1.3 }}
            >
              {title}
            </Title>
            {description && (
              <Text size="sm" lh={1.55} style={{ maxWidth: 560 }}>
                {description}
              </Text>
            )}
          </Box>
          {right}
        </Flex>
      </Flex>
    </Paper>
  );
};
